import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface AccentColorPickerProps {
  onColorChange?: (color: string) => void;
  className?: string;
}

const AccentColorPicker: React.FC<AccentColorPickerProps> = ({ onColorChange, className = '' }) => {
  const { accentColor, setAccentColor, updateAccentColor } = useTheme();

  const predefinedColors = [
    '#3B82F6', // Blue
    '#EF4444', // Red
    '#10B981', // Green
    '#F59E0B', // Yellow
    '#8B5CF6', // Purple
    '#EC4899', // Pink
    '#06B6D4', // Cyan
    '#84CC16', // Lime
    '#F97316', // Orange
    '#6366F1', // Indigo
    '#14B8A6', // Teal
    '#A855F7', // Violet
  ];

  const handleColorChange = async (color: string) => {
    try {
      await updateAccentColor(color);
      onColorChange?.(color);
    } catch (error) {
      console.error('Error updating accent color:', error);
    }
  };

  return (
    <div className={`space-y-4 ${className}`}>
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Accent Color
        </label>
        <div className="flex items-center space-x-3">
          <input
            type="color"
            value={accentColor}
            onChange={(e) => setAccentColor(e.target.value)}
            onBlur={(e) => handleColorChange(e.target.value)}
            className="h-10 w-20 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-accent-color focus:border-accent-color cursor-pointer"
          />
          <span className="text-sm text-gray-500 dark:text-gray-400 font-mono">{accentColor}</span>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Quick Colors
        </label>
        <div className="grid grid-cols-6 gap-2">
          {predefinedColors.map((color) => (
            <button
              key={color}
              onClick={() => handleColorChange(color)}
              className={`h-8 w-8 rounded-md border-2 transition-all hover:scale-110 ${
                accentColor === color 
                  ? 'border-gray-900 dark:border-gray-100 ring-2 ring-gray-300 dark:ring-gray-600' 
                  : 'border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500'
              }`}
              style={{ backgroundColor: color }}
              title={color}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccentColorPicker;
